import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=2278b0d6&scoped=true&lang=html&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2278b0d6",
  null
  
)

export default component.exports